import { Link, NextImage } from "@jog/react-components";
import { asImageSrc, isFilled } from "@prismicio/helpers";
export const BannerTile = ({ banner }) => {
    if (!(banner === null || banner === void 0 ? void 0 : banner.enabled) || !isFilled.image(banner.img))
        return;
    return (<div className="col-span-full">
            <div className="relative flex h-full w-full flex-col">
                <NextImage width={banner.img.dimensions.width} height={banner.img.dimensions.height} src={asImageSrc(banner.img)} alt={banner.img.alt} className="h-full w-full object-cover"/>
                <Link href={banner.link} aria-label={banner.img.alt} className="absolute inset-0"/>
            </div>
        </div>);
};
